export default {
    darkPrimary: "#212121",
    primary:  "#212121",
    secondary:  "#2B78FE",
    secondaryBg: "#2B78FE",
    onSecondary: "#fafafa",
    onPrimary: "#fafafa"
  };